import React from "react"

function About(){

     return  <div>
                <h1>About</h1>
                <p>This is a test website</p>
                <p>It was made following the Youtube channel: </p>
                <a href="https://www.youtube.com/channel/UCJebzvfCuA5ymtb79DQm36A"> Get __it Done!</a>
            </div>
}

export default About



// WEBPACK FOOTER //
// ./src/components/about.js